// extracted by mini-css-extract-plugin
module.exports = {"board_container":"certificate_board_container__HZpcE","artboard_container":"certificate_artboard_container__3Ezqg","artboard":"certificate_artboard__1cHvU"};